import MediaStorageService from './media/storage'

export default {
  MediaStorageService
}
